import React from 'react';
import ForgotPassword from './ForgotPassword';
import PasswordNavbar from '../components/layout/PasswordNavBar';

const PasswordPage = () => {
  return (
    <div>
        <PasswordNavbar />
        <ForgotPassword />
    </div>
  )
}

export default PasswordPage